import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { Select } from '../forms/Select';

export const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const languageOptions = availableLanguages.map(lang => ({
    value: lang.code,
    label: lang.nativeName,
  }));

  const handleLanguageChange = (value: string | string[]) => {
    const selectedLanguage = Array.isArray(value) ? value[0] : value;
    changeLanguage(selectedLanguage);
  };

  return (
    <div className="flex items-center gap-2">
      <span className="material-icons text-gray-600 dark:text-gray-400">language</span>
      <Select
        value={currentLanguage}
        onChange={handleLanguageChange}
        options={languageOptions}
        className="w-32"
        size="sm"
        placeholder="Language"
      />
    </div>
  );
};
